import { render, staticRenderFns } from "./CreateBuyOrderButton.vue?vue&type=template&id=b0614c64&scoped=true&"
import script from "./CreateBuyOrderButton.vue?vue&type=script&lang=js&"
export * from "./CreateBuyOrderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0614c64",
  null
  
)

export default component.exports